import {
  createValidationResult,
  findObjectForPropertyInModelContext,
  IModelContext,
  IValidationResult,
  ModelItem,
  ValidationFunction
} from '@mng/model';
import { SvPerson, SvPersonenData } from '../svangebot.model.types';
import { ITEM_SV_PERSONEN_DATA_PERSONEN } from '../svangebot.model.paths';

export const svPersonenValidation: ValidationFunction = (
  modelItem: ModelItem,
  modelContext: IModelContext
): IValidationResult => {
  const svPersonenData: SvPersonenData = findObjectForPropertyInModelContext(
    modelContext,
    ITEM_SV_PERSONEN_DATA_PERSONEN
  );

  const id = 'personen';

  if (!svPersonenData || !(svPersonenData.personen?.length > 0)) {
    return createValidationResult(id, svPersonenData, 'Es muss 1 VN definiert sein');
  }

  const vns: SvPerson[] = svPersonenData.personen.filter((person) => person.personRollen?.vn);

  if (vns.length !== 1) {
    return createValidationResult(id, svPersonenData, 'Es muss 1 VN definiert sein');
  }

  const vn2s: SvPerson[] = svPersonenData.personen.filter((person) => person.personRollen?.vn2);
  if (vns.some((vn) => vn.stammdaten?.geschlecht === 'D') || vn2s.some((vp) => vp.stammdaten?.geschlecht === 'D')) {
    return createValidationResult(
      id,
      svPersonenData,
      'Die Erstellung von Angeboten mit Personen mit dem Geschlecht "Divers" befindet sich in Umsetzung und wird derzeit leider noch nicht unterstützt!'
    );
  }

  return null;
};
